<template>    
    <v-container v-if="check">
        <v-alert type="success" :value="success" transition="slide-x-transition">
          Vaše údaje boli úspešne zmenené
        </v-alert>
        <v-row justify="center">
            <h2>
                <span class="pa-1">Môj profil</span>
            </h2>
        </v-row>  
       
        <v-card
          color="accent lighten-2"
          height="150px"
          class="elevation-6"
        >
            <v-list-item class="my-20">
                <v-list-item-avatar size="60" class="mx-1" color="accent">
                    <v-icon color="white" size="55">
                        mdi-account-circle
                    </v-icon>
                </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="title my-10">
                    <h3 class="white--text ml-5">{{ person.name }} {{ person.surname }}</h3>
                </v-list-item-title>
            </v-list-item-content>
   
            </v-list-item>
        </v-card>
          <v-timeline
            dense
          >
            <v-timeline-item
              color="accent"
              small
            >
              <div>
                <strong>Cena upratovania za hodinu:</strong> {{person.price}} €
              </div>
            </v-timeline-item>
            <v-timeline-item
              color="accent"
              small
            >
              <div>
                <div><strong>Niečo o tebe:</strong> <br> {{person.info}}</div>
              </div>
            </v-timeline-item>
          </v-timeline>
         <v-row class="justify-center">
            <v-col class="text-center" cols="12">
                <v-btn color="accent" @click="redirectToUpdateProfile()"
                >
                    Upraviť údaje
                </v-btn>
                &nbsp;&nbsp;&nbsp;
                <v-btn color="accent" @click="redirectToChangePassword()"
                >
                    Zmeniť heslo
                </v-btn>
            </v-col>

        </v-row>
      </v-container>
    <v-container v-else>
        <v-row justify="center">
            <h3>
                <span class="pa-1">Pre zobrazenie tejto stránky je potrebné prihlásiť sa.</span>
            </h3>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import store from "../../store/store";
    export default {
        name: "profile",
        data: () => ({
            person:{},
            check: true,
            success: false,
        }),
        methods: {
            getPersonalInfo(){
                axios.get(store.state.url.concat('getPersonalInfo.php'), {
                    params: {
                        user: localStorage.getItem('loggedUserId')
                    }
                }).then((response) => {
                    if(response.data.result == 'ok') {
                        this.person = response.data;
                        this.check = true;
                        this.$emit('check');
                    }
                    else{
                        this.check = false;
                        this.$emit('check');
                    }

                })
            },
            redirectToUpdateProfile() {
                this.$router.push({name: 'updateProfile'});
            },
            redirectToChangePassword() {
                this.$router.push({name: 'changePassword'});
            },
            alertProfileChanged() {
                this.success = true;
                setTimeout(() => {
                    this.success = false;
                }, 2500)
            },
        },
        created(){
            this.getPersonalInfo();
        }
    }
</script>



